var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpaceAndAstronomy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Astronomy-Telescope-Stars--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Astronomy Telescope Stars Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.33 11.57a0.5 0.5 0 0 0 0 -0.38l-0.65 -1.84a0.5 0.5 0 0 0 -0.68 -0.3l-4.09 1.5a1 1 0 0 0 -0.6 1.28l0.33 0.9a1 1 0 0 0 1.28 0.6l4.13 -1.5a0.51 0.51 0 0 0 0.28 -0.26Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 24a1 1 0 0 0 1 -1v-4a0.26 0.26 0 0 1 0.19 -0.24 0.24 0.24 0 0 1 0.28 0.12l2.55 4.59a1 1 0 1 0 1.75 -1l-4.89 -8.81a1 1 0 0 0 -1.75 0L4.28 22.5a1 1 0 0 0 0.39 1.36 1 1 0 0 0 0.48 0.12 1 1 0 0 0 0.85 -0.51l2.55 -4.59a0.24 0.24 0 0 1 0.28 -0.12A0.25 0.25 0 0 1 9 19v4a1 1 0 0 0 1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.5 5.52 -2.74 1a1.47 1.47 0 0 0 -0.88 1.88l1 2.76a1.46 1.46 0 0 0 1.39 1 1.49 1.49 0 0 0 0.5 -0.08l2.73 -1a0.53 0.53 0 0 0 0.29 -0.26 0.5 0.5 0 0 0 0 -0.38l-1.66 -4.6a0.49 0.49 0 0 0 -0.63 -0.32Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.61 11a1.81 1.81 0 0 0 0.39 -0.05l4.25 -1.18a1.47 1.47 0 0 0 0.92 -0.77 1.52 1.52 0 0 0 0.08 -1.18L19.3 2.43a1.46 1.46 0 0 0 -0.81 -0.86 1.49 1.49 0 0 0 -1.19 0l-4 1.82a1.48 1.48 0 0 0 -0.78 1.85L14.21 10a1.5 1.5 0 0 0 1.4 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 21.12a0.61 0.61 0 0 0 0.58 0.41 0.63 0.63 0 0 0 0.59 -0.41L21 18.9a0.22 0.22 0 0 1 0.14 -0.14l2.22 -0.84a0.62 0.62 0 0 0 0 -1.16l-2.23 -0.84a0.22 0.22 0 0 1 -0.14 -0.14l-0.83 -2.22a0.65 0.65 0 0 0 -1.17 0l-0.83 2.22a0.26 0.26 0 0 1 -0.15 0.14l-2.22 0.84a0.62 0.62 0 0 0 0 1.16l2.22 0.84a0.23 0.23 0 0 1 0.15 0.14Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.57 3.89 1.82 0.68a0.26 0.26 0 0 1 0.15 0.14l0.68 1.82a0.5 0.5 0 0 0 0.93 0l0.68 -1.82A0.26 0.26 0 0 1 5 4.57l1.81 -0.68a0.51 0.51 0 0 0 0.33 -0.47 0.5 0.5 0 0 0 -0.35 -0.42L5 2.27a0.28 0.28 0 0 1 -0.15 -0.15L4.15 0.31a0.52 0.52 0 0 0 -0.93 0l-0.68 1.81a0.28 0.28 0 0 1 -0.15 0.15L0.57 3a0.5 0.5 0 0 0 -0.32 0.47 0.51 0.51 0 0 0 0.32 0.42Zm4.35 0.58Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpaceAndAstronomy);
export default ForwardRef;